import {
  BugReport,
  FeedbackAnalytics,
  FeedbackForAdmin,
  SystemStatusReport
} from '@cpd-app/generated';

export const systemStatusFeatureKey = 'systemStatus';

/**
 * Tracks the outcome of loading the published system reports, so the status page
 * can tell "no issues reported" apart from "we could not find out".
 *
 * Without this the two are indistinguishable: the reports list starts empty and
 * there was no failure handler, so an unreachable backend left it empty and the
 * page rendered "All Systems Operational". The one moment the page most needed to
 * say something was wrong, it said the opposite.
 */
export type SystemReportsStatus = 'idle' | 'loading' | 'loaded' | 'unavailable';

export interface SystemStatusState {
  loading: boolean;
  issues: BugReport[];
  feedbacks: FeedbackForAdmin[];
  systemReports: SystemStatusReport[];
  systemReportsStatus: SystemReportsStatus;
  analytics: FeedbackAnalytics;
}

export const initialSystemStatusState: SystemStatusState = {
  loading: false,
  issues: [],
  feedbacks: [],
  systemReports: [],
  systemReportsStatus: 'idle',
  analytics: null
};
